export default "__VITE_ASSET__cb2dd248__"